// Rybbit analytics — mirrors the tracking setup on birkebaek site.
// Script is loaded in root.tsx (when VITE_RYBBIT_SITE_ID is set); this module provides typed wrappers
// for custom event tracking so callers don't use raw rybbit.track().

declare global {
  interface Window {
    rybbit?: {
      track: (event: string, props?: Record<string, string | number | boolean>) => void
    }
  }
}

function track(event: string, props?: Record<string, string | number | boolean>) {
  window.rybbit?.track(event, props)
}

export const analytics = {
  /** Primary CTA click — "Book møde" button anywhere on the page */
  ctaClick(label: string, href: string) {
    track('cta_click', { label, href })
  },

  /** Email link click */
  emailClick(source: string) {
    track('email_click', { source })
  },

  /** Phone link click */
  phoneClick(source: string) {
    track('phone_click', { source })
  },

  /** Package card CTA clicked */
  packageClick(title: string, price: number) {
    track('package_click', { title, price })
  },

  /** Case card clicked */
  caseClick(title: string, slug: string) {
    track('case_click', { title, slug })
  },

  /** Blog post clicked */
  postClick(title: string, slug: string) {
    track('post_click', { title, slug })
  },

  /** Hamburger menu opened */
  mobileMenuOpen() {
    track('mobile_menu_open')
  },
}
